import FullWidthSection from '@/components/full-width-section';
import ImageOptimizer from '@/components/image-optimizer';

const CautionOverview = ({
  title,
  content,
}: {
  title: string;
  content: string;
}) => {
  return (
    <FullWidthSection className="bg-sub-darknavy text-white">
      <section className="desktop:web-w desktop:mx-auto relative overflow-hidden py-10 text-white">
        <div className="bg-white-rhombus-pattern transform2 absolute top-0 right-3 h-7.5 w-40.5"></div>
        <div className="px-6">
          <div className="typo-18 desktop:typo-20 mb-4 flex font-bold">
            <ImageOptimizer
              src="/images/icons/icon_error.svg"
              alt=""
              width={20}
              height={20}
              className="mr-1"
            />
            {title}
          </div>
          <p className="typo-15 desktop:typo-16 desktop:leading-relaxed leading-relaxed font-medium whitespace-pre-line text-white/70">
            {content}
          </p>
        </div>
      </section>
    </FullWidthSection>
  );
};

export default CautionOverview;
